<template>
  <div class="admin-categories">
    <header-title title="Categorías"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        :style="adminNavigationBackTheme"
        @click="openCatDialog('addCat')"
      >
        + Nueva
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="categorySelected"
            :items="categories"
            item-text="name"
            item-value="id"
            label="Categoría"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="productTypeSelected"
            :items="productTypesCollection"
            item-text="name"
            item-value="id"
            label="Tipo de producto"
          ></v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <button
            class="admin-reset-filters"
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </button>
        </v-col>
      </v-row>
    </v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="sortCategories(categories)"
          class="elevation-1"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.id`]="{ item }">
            <div
              v-for="(subCategory, index) in subCategories(item.id)"
              :key="`subCategory_${index}`"
            >
              <v-btn
                rounded
                dark
                :x-small="true"
                class="subcategory-info"
                :style="{ 'background-color': subCategoryTagBackgroundTheme }"
                >{{ subCategory.name }}
              </v-btn>
            </div>
          </template>

          <template v-slot:[`item.group_order_id`]="{ item }">
            <v-btn rounded color="blue-grey" dark :x-small="true"
              >{{ groupOrderName(item.group_order_id) }}
            </v-btn>
          </template>

          <template v-slot:[`item.type_order_id`]="{ item }">
            <div
              v-for="(typeOrder, index) in typeOrders(item.type_order_id)"
              :key="`typeOrder_${index}`"
              class="d-flex justify-start"
            >
              <v-btn rounded color="grey" dark :x-small="true"
                >{{ typeOrder.name }}
              </v-btn>
            </div>
          </template>

          <template v-slot:[`item.product_type_id`]="{ item }">
            <v-btn
              v-if="isTypeDrinks(item.product_type_id)"
              rounded
              dark
              :x-small="true"
              class="product-kind-info"
              :style="{ 'background-color': drinksTagBackgroundTheme }"
              >{{ productTypeName(item.product_type_id) }}
            </v-btn>
            <v-btn
              v-if="isTypeFood(item.product_type_id)"
              rounded
              dark
              :x-small="true"
              class="subcategory-info"
              :style="{ 'background-color': foodTagBackgroundTheme }"
              >{{ productTypeName(item.product_type_id) }}
            </v-btn>
            <v-btn
              v-if="isTypeDessert(item.product_type_id)"
              rounded
              dark
              :x-small="true"
              class="subcategory-dessert"
              :style="{ 'background-color': dessertTagBackgroundTheme }"
              >{{ productTypeName(item.product_type_id) }}
            </v-btn>
          </template>

          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openCatDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>

          <template v-slot:[`item.deleteAction`]="{ item }">
            <v-icon class="mr-2" @click="deleteCategoryDialog(item.id)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <CategoryDialog ref="categoryDialog"></CategoryDialog>

    <v-row justify="center">
      <DeleteCategoryDialog
        :dialog="dialog"
        @cancel="deleteCancel"
        @deleteCategories="deleteCategories"
      ></DeleteCategoryDialog>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { orderBy } from "lodash";
import CategoryDialog from "../../../components/admin/category/CategoryDialog";
import DeleteCategoryDialog from "@/components/admin/category/DeleteCategoryDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { CategoriesTableHeader } from "@/utils/tableHeaderconstants";
import { productTypesCollection } from "@/collections/productTypes";
import { subCategoriesCollection } from "@/collections/subCategories";
import { groupOrdersCollection } from "@/collections/groupOrders";
import { typeOrdersCollection } from "@/collections/typeOrders";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { categoriesCollection, deleteCategory } from "@/collections/categories";
// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "categories",
  components: {
    CategoryDialog,
    DeleteCategoryDialog,
    HeaderTitle
  },
  data() {
    return {
      search: "",
      productTypesCollection: [],
      categoriesCollection: [],
      subCategoriesCollection: [],
      groupOrdersCollection: [],
      typeOrdersCollection: [],
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: [],
      productTypeSelected: "",
      categorySelected: "",
      dialog: false,
      selectedCategoryId: null,
      headers: [...CategoriesTableHeader]
    };
  },
  firestore() {
    return {
      productTypesCollection: productTypesCollection,
      categoriesCollection: categoriesCollection,
      subCategoriesCollection: subCategoriesCollection,
      groupOrdersCollection: groupOrdersCollection,
      typeOrdersCollection: typeOrdersCollection,
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection
    };
  },
  computed: {
    categories() {
      if (this.categorySelected !== "" && this.productTypeSelected !== "") {
        return this.categoriesCollection.filter(
          category =>
            this.categorySelected === category.id &&
            this.productTypeSelected === category.product_type_id
        );
      }

      if (this.productTypeSelected !== "") {
        return this.categoriesCollection.filter(
          category => this.productTypeSelected === category.product_type_id
        );
      }

      return this.categorySelected !== ""
        ? this.categoriesCollection.filter(
            category => this.categorySelected === category.id
          )
        : this.categoriesCollection;
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  methods: {
    isTypeDrinks(id) {
      return id === this.$store.state.productTypeIds.drinks;
    },
    isTypeFood(id) {
      return id === this.$store.state.productTypeIds.food;
    },
    isTypeDessert(id) {
      return id === this.$store.state.productTypeIds.dessert;
    },
    subCategories(categoryId) {
      return this.subCategoriesCollection.filter(
        subCategory => categoryId === subCategory.category_id
      );
    },
    groupOrderName(groupOrderId) {
      let groupOrder = this.groupOrdersCollection.find(
        x => groupOrderId === x.id
      );
      return groupOrder ? groupOrder.name : "";
    },
    typeOrders(typeOrderId) {
      return this.typeOrdersCollection.filter(
        typeOrder => typeOrderId === typeOrder.id
      );
    },
    productTypeName(id) {
      return this.getProductTypeName(this.productTypesCollection, id);
    },
    sortCategories(categories) {
      return (
        categories &&
        orderBy(
          categories,
          o => {
            return moment(
              o.updated_on ||
                moment()
                  .subtract(1, "M")
                  .format()
            );
          },
          ["desc"]
        )
      );
    },
    resetFilters() {
      this.categorySelected = "";
      this.productTypeSelected = "";
    },
    openCatDialog(itemId) {
      this.$refs.categoryDialog.open(itemId);
    },
    deleteCategories() {
      let category = this.categoriesCollection.find(
        element => this.selectedCategoryId === element.id
      );

      let subCategoriesNames = [];
      this.subCategories(this.selectedCategoryId).forEach(element => {
        subCategoriesNames.push(element.name);
      });

      if (category.hasSubCategories && subCategoriesNames.length > 0) {
        let title = `Esta categoría está asignada a la subcategoría:${subCategoriesNames.join(
          ","
        )}`;
        this.showErrorMessage(title);
        return;
      }

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
      ) {
        this.deleteOrShowToast(this.foodCollection, this.selectedCategoryId);
        return;
      }

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
      ) {
        this.deleteOrShowToast(this.drinksCollection, this.selectedCategoryId);
        return;
      }

      if (
        category.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
      ) {
        this.deleteOrShowToast(this.dessertCollection, this.selectedCategoryId);
        return;
      }

      this.deleteCategoryById(this.selectedCategoryId);
    },
    deleteOrShowToast(collection, categoryId) {
      let productNames = [];
      collection
        .filter(element => categoryId === element.category_id)
        .forEach(element => {
          productNames.push(element.name);
        });

      if (productNames.length > 0) {
        this.getToastMessage(productNames);
        return;
      }

      this.deleteCategoryById(categoryId);
    },
    async deleteCategoryById(categoryId) {
      try {
        await deleteCategory(categoryId);
        this.selectedSubCategoryId = null;
        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "delete_category",
          "Obtained error message in deleteCategoryById()",
          error.stack,
          this.$options.name
        );
        this.dialog = false;
      }
    },
    getToastMessage(productNames) {
      let title = `Esta categoría está asignada al producto: ${productNames.join(
        ","
      )}`;
      this.showErrorMessage(title);
    },
    deleteCategoryDialog(id) {
      this.selectedCategoryId = id;
      this.dialog = true;
    },
    deleteCancel() {
      this.dialog = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>

<style>
.category-image {
  width: 60px;
  height: 60px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
}
.category-image img {
  max-width: 100%;
  max-height: 80px;
}
</style>
